module.exports = __webpack_public_path__ + "static/media/Arian Saeedfar.2a7e3d6b.png";